const baseURL = process.env.REACT_APP_DEALBASE_BASE_API;

export const fetchContractKeywordSuggestions = async (keyword, userId) => {
  const axios = (await import("axios")).default;

  // Read activeTab from localStorage
  let activeTabData = {};
  try {
    activeTabData = JSON.parse(localStorage.getItem("activeTab")) || {};
  } catch {
    activeTabData = {};
  }

  // Find active key (the one that’s true)
  const activeKey = Object.keys(activeTabData).find((key) => activeTabData[key]);

  // Map to actual index name for API
  let activeIndex = "contracts";
  if (activeKey === "contractType") activeIndex = "contracts";
  else if (activeKey === "clause") activeIndex = "clauses";
  else if (activeKey === "definition") activeIndex = "definitions";

  const payload = {
    _query: keyword,
    user_id: userId,
    filters: {},
    type: "text_search",
    _index: activeIndex,
  };

  try {
    const response = await axios.post(
      `${baseURL}/api/suggestion_search/?limit=10&offset=0&sort=relevance`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data || [];
  } catch (error) {
    console.error("❌ Error fetching contract keyword suggestions:", error);
    return [];
  }
};
